import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../../core';
import { Cliente } from '../cliente';
import { ClienteCondicaoPagamento } from '../condicao-pagamento';
import { ClienteCidadeEstado } from '../cidade-estado';
import { ClienteUnidadeNegocio } from '../unidade-negocio';
import { ClienteLinhaProducao } from '../unidade-negocio/linha-producao';

@Injectable({
    providedIn: 'root'
})
export class ClienteSearchesHttpService {
    private pathApi: string;

    constructor(private configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/cliente`;
    }

    /** Procura um único cliente através do ID da pessoa informada */
    findByPessoa(idPessoa: number, idRepresentante: number): Observable<Cliente> {
        // Params
        const params = new HttpParams()
                            .append('idRepresentante', idRepresentante ? idRepresentante.toString() : null);

        return this.customHttp.get<Cliente>(`${this.configServerService.getPathApi()}/pessoa/${idPessoa}/cliente`, {params});
    }

    /** Obtem o ID da Pessoa do cliente */
    getIdPessoa(id: number): Observable<number> {
        return this.customHttp.get<number>(`${this.pathApi}/${id}/pessoa/id`);
    }

    /** Obtem o ID do cliente pelo ID da pessoa informado */
    getIdByPessoa(idPessoa: number): Observable<number> {
        return this.customHttp.get<number>(`${this.configServerService.getPathApi()}/pessoa/${idPessoa}/cliente/id`);
    }

    /** Obtem as informações de condições de pagamento do Cliente */
    getCondicaoPagamento(id: number): Observable<ClienteCondicaoPagamento> {
        return this.customHttp.get<ClienteCondicaoPagamento>(`${this.pathApi}/${id}/condicaopagamento`);
    }

    /** Obtem o nome da cidade e estado do cliente */
    getCidadeEstado(id: number): Observable<ClienteCidadeEstado> {
        return this.customHttp.get<ClienteCidadeEstado>(`${this.pathApi}/${id}/cidadeestado`);
    }

    /** Obtem a rota de entrega do cliente no sistema ERP SCR */
    getRotaEntregaErpSCR(id: number): Observable<string> {
        return this.customHttp.get<string>(`${this.pathApi}/${id}/rotaentregaerpscr`);
    }

    /** Pesquisa todas as unidades de negócio do cliente informado */
    searchUnidadesNegocios(id: number, carregarLinhasProducao: boolean): Observable<ClienteUnidadeNegocio[]> {
        // Params
        const params = new HttpParams()
                                .append('carregarLinhasProducao', carregarLinhasProducao ? carregarLinhasProducao.toString() : null);

        return this.customHttp.get<ClienteUnidadeNegocio[]>(`${this.pathApi}/${id}/unidadenegocio`, {params});
    }

    /** Pesquisa todas as linhas de produção da unidade de negócio do cliente informada */
    searchLinhasProducao(idClienteUnidadeNegocio: number): Observable<ClienteLinhaProducao[]> {
        return this.customHttp.get<ClienteLinhaProducao[]>(`${this.pathApi}/0/unidadenegocio/${idClienteUnidadeNegocio}/linhaproducao`);
    }
}
